import { ReactElement } from 'react';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { GhinIndexDateChange } from '../../stateHooks/useGhinIndexDateChange';
import { HANDICAP_LABELS } from '../../utils/handicapUtils';

interface GhinIndexDateChangeConfirmProps {
  change: GhinIndexDateChange;
}

/** The inline confirmation for a Handicap Index date change held by useGhinIndexDateChange because
 *  scores are already published. Renders nothing while no change is waiting. */
export default function GhinIndexDateChangeConfirm({ change }: GhinIndexDateChangeConfirmProps): ReactElement | null {
  if (change.pendingDate === null) return null;
  return (
    <Alert severity="warning" sx={{ alignItems: 'flex-start' }}>
      <Stack spacing={1}>
        <span>Results were previously published. Changing the {HANDICAP_LABELS.INDEX_DATE} could cause results to change.</span>
        <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
          <Button size="small" variant="contained" disabled={change.isProcessing}
            onClick={() => change.applyPending(false)}>
            Confirm and republish
          </Button>
          <Button size="small" disabled={change.isProcessing}
            onClick={() => change.applyPending(true)}>
            Confirm and unpublish
          </Button>
          <Button size="small" disabled={change.isProcessing}
            onClick={change.cancelPending}>
            Cancel
          </Button>
        </Stack>
      </Stack>
    </Alert>
  );
}
